<!-- 院长端 -->
<template>
	<div class="data-summary" ref="summary" style="height: 100%;">
		<div class="page-title">
			<div class="text">{{ excelName }}</div>
			<div class="btn">
				<!-- <el-button size="small" @click="isShowExtraColumns = !isShowExtraColumns">
					{{ isShowExtraColumns ? '隐藏额外列' : '显示额外列' }}
				</el-button> -->
				<el-button size="small" v-print="printObj">打印</el-button>
				<el-button size="small" style="margin-right: 15px;" @click="toExportExcele">导出</el-button>
			</div>
		</div>
		<div style="width: 100%; height: 1px; background: rgba(235, 238, 245, 1); margin-top: 0px; margin-bottom: 16px;">
		</div>
		<div style="display: flex; align-items: center; margin-bottom: 16px;">
			<div
				style="width: 10px; height: 10px; background: rgba(216,216,216,0); border: 3px solid #4A7CE8; border-radius: 5px; margin-left: 24px; margin-right: 4px;">
			</div>
			<div
				style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #2B2B2B; line-height: 20px; text-align: left; font-style: normal;">
				守护老人数量：{{ elderNumber }}</div>
			<div
				style="width: 10px; height: 10px; background: rgba(216,216,216,0); border: 3px solid #4A7CE8; border-radius: 5px; margin-left: 40px; margin-right: 4px;">
			</div>
			<div
				style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #2B2B2B; line-height: 20px; text-align: left; font-style: normal;">
				守护老人天数：{{ dayNumber }}</div>
		</div>
		<div v-if="tableData.length > 0">
			<el-table :data="tableData" :header-cell-style="{
				background: '#F0F0F0',
				color: '#262626',
				padding: '6px 0',
			}" :row-style="{
					height: '30px',
					padding: '6px 0',
					borderSpacing: 0,
					borderCollapse: 'collapse',
				}" :row-class-name="changeTableRowColor" border :span-method="objectSpanMethod"
				@cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
				<!-- 原有：床位列（需要合并） -->
				<el-table-column fixed prop="bedName" label="床位" width="120" align="center">
					<template slot-scope="scope">
						<span :style="{ color: scope.row.bedNameAbnormal === 1 ? '#FF4D4F' : '' }">
							{{ $lodash.get(scope.row, 'bedName', null ) !== null ? $lodash.get(scope.row, 'bedName', null ) : '-' }}
						</span>
					</template>
				</el-table-column>

				<!-- 新增：五列（不需要合并） -->
				<el-table-column v-if="isShowExtraColumns" prop="time" label="时间" width="120"
					align="center">
					<template slot-scope="scope">
						<span>{{ getTimeVal(scope.row) }}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="isShowExtraColumns" prop="oxygenSaturation" label="血氧" width="80"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.oxygenSaturationAbnormal }">{{ getXyVal(scope.row) }}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="isShowExtraColumns" prop="pulseRate" label="脉率" width="80"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.pulseRateAbnormal }">{{ getMlVal(scope.row) }}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="isShowExtraColumns" prop="replaceD" label="血压" width="80"
					align="center">
					<template slot-scope="scope">
						<span v-if="getSsVal(scope.row) != '-' || getSzVal(scope.row) != '-'">
							<span :class="{ abnormal: scope.row.systolicBloodPressureAbnormal }">{{ getSsVal(scope.row) }}</span>
							<span :class="{ abnormal: scope.row.systolicBloodPressureAbnormal && scope.row.diastolicBloodPressureAbnormal }">/</span>
							<span :class="{ abnormal: scope.row.diastolicBloodPressureAbnormal }">{{ getSzVal(scope.row) }}</span>
						</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column v-if="isShowExtraColumns" prop="bodyTemperature" label="体温" width="80"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.bodyTemperatureAbnormal }">{{ getTwVal(scope.row) }}</span>
					</template>
				</el-table-column>

				<!-- 原有：睡眠得分列及之后（按原有规则合并） -->
				<el-table-column prop="score" label="睡眠得分" width="80" align="center">
					<template slot-scope="scope">
						<span>{{ $lodash.get(scope.row, 'score', null ) !== null ? $lodash.get(scope.row, 'score', null ) : '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="getBedIdx" label="上床时间" width="80" align="center">
					<template slot-scope="scope">
						<span>{{ $lodash.get(scope.row, 'getBedIdx', null ) !== null ? $lodash.get(scope.row, 'getBedIdx', null ) : '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="sleepStIdx" label="入睡时间/（00:00前）" width="120"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.sleepStIdxAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'sleepStIdx', null ) !== null ? $lodash.get(scope.row, 'sleepStIdx', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="sleepEdIdx" label="醒来时间" width="80" align="center">
					<template slot-scope="scope">
						<span>{{ $lodash.get(scope.row, 'sleepEdIdx', null ) !== null ? $lodash.get(scope.row, 'sleepEdIdx', null ) : '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="leaveBedIdx" label="起床时间" width="80" align="center">
					<template slot-scope="scope">
						<span>{{ $lodash.get(scope.row, 'leaveBedIdx', null ) !== null ? $lodash.get(scope.row, 'leaveBedIdx', null ) : '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="sleepLenValidMin" label="睡眠时长/（6~10h）" width="120"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.sleepLenValidMinAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'sleepLenValidMintext', null ) !== null ? $lodash.get(scope.row, 'sleepLenValidMintext', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="outBedDuration" label="离床时长/（0~5min）" width="120"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.outBedDurationAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'outBedDurationtext', null ) !== null ? $lodash.get(scope.row, 'outBedDurationtext', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="outBedNum" label="离床次数/（0~2次）" width="120" align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.outBedNumAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'outBedNum', null ) !== null ? $lodash.get(scope.row, 'outBedNum', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="sleepEff" label="睡眠效率/（80%~100%）" width="130"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.sleepEffAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'sleepEff', null ) !== null ? $lodash.get(scope.row, 'sleepEff', null ) + '%' : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="breathMean" label="平均呼吸率/（12~20BPM）" width="140"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.breathMeanAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'breathMean', null ) !== null ? $lodash.get(scope.row, 'breathMean', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="breathMin" label="最低呼吸率/（≥12BPM）" width="140"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.breathMinAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'breathMin', null ) !== null ? $lodash.get(scope.row, 'breathMin', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="breathMax" label="最高呼吸率/（≤24BPM）" width="140"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.breathMaxAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'breathMax', null ) !== null ? $lodash.get(scope.row, 'breathMax', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="heartMean" label="平均心率/（40~90BPM）" width="140"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.heartMeanAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'heartMean', null ) !== null ? $lodash.get(scope.row, 'heartMean', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="heartMin" label="最低心率/（≥40BPM）" width="110" align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.heartMinAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'heartMin', null ) !== null ? $lodash.get(scope.row, 'heartMin', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="heartMax" label="最高心率/（≤90BPM）" width="110" align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.heartMaxAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'heartMax', null ) !== null ? $lodash.get(scope.row, 'heartMax', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="turnOverNum" label="体动次数/（0~60次）" width="140"
					align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.turnOverNumAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'turnOverNum', null ) !== null ? $lodash.get(scope.row, 'turnOverNum', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :render-header="renderheader" prop="ahi" label="呼吸异常指数/（0~5）" width="140" align="center">
					<template slot-scope="scope">
						<span :class="{ abnormal: scope.row.ahiAbnormal === 1 }">
							{{ $lodash.get(scope.row, 'ahi', null ) !== null ? $lodash.get(scope.row, 'ahi', null ) : '-' }}
						</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<NoData v-if="tableData.length <= 0" />
		<div class="pagination" v-if="pages > 1">
			<a-pagination :current="current" :total="total" :defaultPageSize="pageSize" show-less-items
				@change="showSizeChange" />
		</div>

		<!-- 打印用表格：同步添加合并方法，确保规则一致 -->
		<div id="pointPdf" class="pointPdf1">
			<div v-for="(item, index) in copyTableData" :key="index">
				<!-- 打印表格1：添加 :span-method="objectSpanMethod" -->
				<div style="page-break-after: always;border-bottom:1px solid #e6ebf5;padding-top:10px;">
					<el-table :data="item" :header-cell-style="{ color: '#262626', padding: '6px 0' }"
						:row-style="{ height: '25px', padding: '6px 0' }" border :span-method="objectSpanMethod">
						<!-- 原有：床位列（需要合并） -->
						<el-table-column fixed prop="bedName" label="床位" width="150" align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.bedNameAbnormal === 1 }">
									{{ scope.row.bedName || '' }}
								</span>
							</template>
						</el-table-column>

						<!-- 新增：五列（不需要合并） -->
						<el-table-column v-if="isShowExtraColumns" prop="time" label="时间" width="120"
							align="center">
							<template slot-scope="scope">
								<span>{{ getTimeVal(scope.row) }}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="oxygenSaturation" label="血氧" width="80"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.oxygenSaturationAbnormal }">{{ getXyVal(scope.row) }}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="pulseRate" label="脉率" width="80"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.pulseRateAbnormal }">{{ getMlVal(scope.row) }}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="replaceD" label="血压" width="80"
							align="center">
							<template slot-scope="scope">
								<span v-if="getSsVal(scope.row) != '-' || getSzVal(scope.row) != '-'">
									<span :class="{ abnormal: scope.row.systolicBloodPressureAbnormal }">{{ getSsVal(scope.row) }}</span>
									<span :class="{ abnormal: scope.row.systolicBloodPressureAbnormal && scope.row.diastolicBloodPressureAbnormal }">/</span>
									<span :class="{ abnormal: scope.row.diastolicBloodPressureAbnormal }">{{ getSzVal(scope.row) }}</span>
								</span>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="bodyTemperature" label="体温" width="80"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.bodyTemperatureAbnormal }">{{ getTwVal(scope.row) }}</span>
							</template>
						</el-table-column>

						<!-- 原有列（按规则合并） -->
						<el-table-column prop="score" label="睡眠得分" width="80" align="center">
							<template slot-scope="scope">
								<span>{{ $lodash.get(scope.row, 'score', null ) !== null ? $lodash.get(scope.row, 'score', null ) : '-' }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="getBedIdx" label="上床时间" width="80" align="center">
							<template slot-scope="scope">
								<span>{{ $lodash.get(scope.row, 'getBedIdx', null ) !== null ? $lodash.get(scope.row, 'getBedIdx', null ) : '-' }}</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="sleepStIdx" label="入睡时间/（00:00前）" width="120"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.sleepStIdxAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'sleepStIdx', null ) !== null ? $lodash.get(scope.row, 'sleepStIdx', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="sleepEdIdx" label="醒来时间" width="80" align="center">
							<template slot-scope="scope">
								<span>{{ $lodash.get(scope.row, 'sleepEdIdx', null ) !== null ? $lodash.get(scope.row, 'sleepEdIdx', null ) : '-' }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="leaveBedIdx" label="起床时间" width="80" align="center">
							<template slot-scope="scope">
								<span>{{ $lodash.get(scope.row, 'leaveBedIdx', null ) !== null ? $lodash.get(scope.row, 'leaveBedIdx', null ) : '-' }}</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="sleepLenValidMin" label="睡眠时长/（6~10h）" width="120"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.sleepLenValidMinAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'sleepLenValidMintext', null ) !== null ? $lodash.get(scope.row, 'sleepLenValidMintext', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="outBedDuration" label="离床时长/（0~5min）" width="110"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.outBedDurationAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'outBedDurationtext', null ) !== null ? $lodash.get(scope.row, 'outBedDurationtext', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="outBedNum" label="离床次数/（0~2次）" width="110"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.outBedNumAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'outBedNum', null ) !== null ? $lodash.get(scope.row, 'outBedNum', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="sleepEff" label="睡眠效率/（80%~100%）" width="130"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.sleepEffAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'sleepEff', null ) !== null ? $lodash.get(scope.row, 'sleepEff', null ) + '%' : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="breathMean" width="140" label="平均呼吸率/（12~20BPM）"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.breathMeanAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'breathMean', null ) !== null ? $lodash.get(scope.row, 'breathMean', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!-- 打印表格2：添加 :span-method="objectSpanMethod" -->
				<div style="page-break-after: always;border-bottom:1px solid #e6ebf5;padding-top:10px;">
					<el-table :data="item" :header-cell-style="{ color: '#262626', padding: '6px 0' }"
						:row-style="{ height: '25px', padding: '6px 0' }" border :span-method="objectSpanMethod">
						<!-- 原有：床位列（需要合并） -->
						<el-table-column fixed prop="bedName" label="床位" width="150" align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.bedNameAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'bedName', null ) !== null ? $lodash.get(scope.row, 'bedName', null ) : '-' }}
								</span>
							</template>
						</el-table-column>

						<!-- 新增：五列（不需要合并） -->
						<el-table-column v-if="isShowExtraColumns" prop="time" label="时间" width="120"
							align="center">
							<template slot-scope="scope">
								<span>{{ getTimeVal(scope.row) }}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="oxygenSaturation" label="血氧" width="80"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.oxygenSaturationAbnormal }">{{ getXyVal(scope.row) }}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="pulseRate" label="脉率" width="80"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.pulseRateAbnormal }">{{ getMlVal(scope.row) }}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="replaceD" label="血压" width="80"
							align="center">
							<template slot-scope="scope">
								<span v-if="getSsVal(scope.row) != '-' || getSzVal(scope.row) != '-'">
									<span :class="{ abnormal: scope.row.systolicBloodPressureAbnormal }">{{ getSsVal(scope.row) }}</span>
									<span :class="{ abnormal: scope.row.systolicBloodPressureAbnormal && scope.row.diastolicBloodPressureAbnormal }">/</span>
									<span :class="{ abnormal: scope.row.diastolicBloodPressureAbnormal }">{{ getSzVal(scope.row) }}</span>
								</span>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column v-if="isShowExtraColumns" prop="bodyTemperature" label="体温" width="80"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.bodyTemperatureAbnormal }">{{ getTwVal(scope.row) }}</span>
							</template>
						</el-table-column>

						<!-- 原有列（按规则合并） -->
						<el-table-column :render-header="renderheader" prop="breathMin" label="最低呼吸率/（≥12BPM）" width="150"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.breathMinAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'breathMin', null ) !== null ? $lodash.get(scope.row, 'breathMin', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="breathMax" label="最高呼吸率/（≤24BPM）" width="150"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.breathMaxAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'breathMax', null ) !== null ? $lodash.get(scope.row, 'breathMax', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="heartMean" label="平均心率/（40~90BPM）" width="150"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.heartMeanAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'heartMean', null ) !== null ? $lodash.get(scope.row, 'heartMean', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="heartMin" label="最低心率/（≥40BPM）" width="150"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.heartMinAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'heartMin', null ) !== null ? $lodash.get(scope.row, 'heartMin', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="heartMax" label="最高心率/（≤90BPM）" width="150"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.heartMaxAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'heartMax', null ) !== null ? $lodash.get(scope.row, 'heartMax', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="turnOverNum" label="体动次数/（0~60次）" width="150"
							align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.turnOverNumAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'turnOverNum', null ) !== null ? $lodash.get(scope.row, 'turnOverNum', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
						<el-table-column :render-header="renderheader" prop="ahi" label="呼吸异常指数/（0~5）" width="150" align="center">
							<template slot-scope="scope">
								<span :class="{ abnormal: scope.row.ahiAbnormal === 1 }">
									{{ $lodash.get(scope.row, 'ahi', null ) !== null ? $lodash.get(scope.row, 'ahi', null ) : '-' }}
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import NoData from './noData.vue';
export default {
	components: { NoData },
	data() {
		return {
			printObj: {
				id: 'pointPdf',
				popTitle: '清雷科技',
			},
			excelName: '',
			current: 1,
			pages: 1,
			total: 1,
			pageSize: 20,
			preDate: '',
			tableData: [],
			copyTableData: [],
			dayNumber: 0,
			elderNumber: 0,
			displayRowIndexes: [],
			mergeGroups: [],
			currentHoverGroup: [],
			hoverRowIndex: -1,
			isShowExtraColumns: true,
			// 新增：存储合并规则所需的数组（避免重复声明）
			bedNameSpans: [],
			getBedIdxSpans: [],
			currentBedName: "",
			sameBedNameCount: 0,
			extraSpans: []
		};
	},
	created() {
		console.log(this.$getCookie('userInfo'));
		let timeData = new Date();
		this.excelName =
			timeData.getMonth() + 1 + '月' + timeData.getDate() + '日' + this.$getCookie('userInfo').user.tenantName + '健康数据汇总';
		this.preDate = new Date(timeData.getTime()); //前一天
		let endMonth = this.preDate.getMonth() + 1 >= 10 ? this.preDate.getMonth() + 1 : '0' + (this.preDate.getMonth() + 1);
		let endDay = this.preDate.getDate() >= 10 ? this.preDate.getDate() : '0' + this.preDate.getDate();
		this.preDate = this.preDate.getFullYear() + '-' + endMonth + '-' + endDay;
		this.getTableData(1, this.pageSize, this.preDate);
		this.getTableData(1, 20000, this.preDate);
		this.getGuardElderInfo();
	},
	mounted() {
		this.$refs.summary.style.width = window.innerWidth + 'px';
	},
	methods: {
		getTimeVal(item) {
			return this.$lodash.get(item, "time", "-" ) !== null ? this.$lodash.get(item, "time", "-" ) : '-'
		},
		getXyVal(item) {
			return this.$lodash.get(item, "oxygenSaturation", "-" ) !== null ? this.$lodash.get(item, "oxygenSaturation", "-" ) : '-'
		},
		getMlVal(item) {
			return this.$lodash.get(item, "pulseRate", "-" ) !== null ? this.$lodash.get(item, "pulseRate", "-" ) : '-'
		},
		getSsVal(item) {
			let str = (this.$lodash.get(item, "systolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "systolicBloodPressure", "-" ) : '-');
			return str;
		},
		getSzVal(item) {
			let str = (this.$lodash.get(item, "diastolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "diastolicBloodPressure", "-" ) : '-');
			return str;
		},
		getTwVal(item) {
			return this.$lodash.get(item, "bodyTemperature", "-" ) !== null ? this.$lodash.get(item, "bodyTemperature", "-" ) : '-'
		},

		// 计算“床位”和“上床时间”列的合并规则（原有逻辑保留）
		calculateSpanMethods() {
			this.bedNameSpans = [];
			this.getBedIdxSpans = [];
			// 新增：初始化「睡眠得分及之后列」的合并数组
			this.extraSpans = [];
			this.displayRowIndexes = [];
			this.currentBedName = "";
			this.sameBedNameCount = 0;
			this.mergeGroups = [];
			let currentGroup = null;

			this.tableData.forEach((row, index) => {
				if (row.bedName === this.currentBedName) {
					// 与上一行床位相同：延长所有需合并列的行数
					this.bedNameSpans[this.bedNameSpans.length - 1].rowspan += 1;
					this.bedNameSpans.push({ rowspan: 0, colspan: 0 });

					this.getBedIdxSpans[this.getBedIdxSpans.length - 1].rowspan += 1;
					this.getBedIdxSpans.push({ rowspan: 0, colspan: 0 });

					// 新增：同步延长「睡眠得分及之后列」的合并行数
					this.extraSpans[this.extraSpans.length - 1].rowspan += 1;
					this.extraSpans.push({ rowspan: 0, colspan: 0 });

					this.sameBedNameCount += 1;
					if (currentGroup) currentGroup.rows.push(index);
				} else {
					// 与上一行床位不同：重新初始化合并规则
					this.currentBedName = row.bedName;
					this.sameBedNameCount = 1;
					this.bedNameSpans.push({ rowspan: this.sameBedNameCount, colspan: 1 });
					this.getBedIdxSpans.push({ rowspan: this.sameBedNameCount, colspan: 1 });
					// 新增：初始化「睡眠得分及之后列」的合并规则（与床位列行数一致）
					this.extraSpans.push({ rowspan: this.sameBedNameCount, colspan: 1 });

					this.displayRowIndexes.push(index);
					currentGroup = { bedName: this.currentBedName, rows: [index] };
					this.mergeGroups.push(currentGroup);
				}
			});
		},

		handleCellMouseEnter(row) {
			const rowIndex = this.tableData.findIndex(
				item => item.bedId === row.bedId && item.statisticsDate === row.statisticsDate
			);
			if (rowIndex === -1) return;

			const targetGroup = this.mergeGroups.find(group => group.rows.includes(rowIndex));
			if (targetGroup) {
				this.currentHoverGroup = targetGroup.rows;
				this.hoverRowIndex = rowIndex;
			} else {
				this.currentHoverGroup = [rowIndex];
				this.hoverRowIndex = rowIndex;
			}
		},

		handleCellMouseLeave() {
			this.currentHoverGroup = [];
			this.hoverRowIndex = -1;
		},

		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (!this.isShowExtraColumns) {
				return {
					rowspan: 1,
					colspan: 1
				};
			}
			// 床位列（第0列）和睡眠得分及之后的列（从第6列开始，根据实际列顺序调整）
			// 注意：列索引需要根据实际表格列顺序确认，这里假设睡眠得分列是第6列
			if (columnIndex === 0 || columnIndex >= 6) {
				const currentBedName = row.bedName;
				let rowspan = 1;

				// 向上查找相同床位的行数
				for (let i = rowIndex - 1; i >= 0; i--) {
					if (this.tableData[i].bedName === currentBedName) {
						return {
							rowspan: 0,
							colspan: 1
						};
					} else {
						break;
					}
				}

				// 向下查找相同床位的行数
				for (let i = rowIndex + 1; i < this.tableData.length; i++) {
					if (this.tableData[i].bedName === currentBedName) {
						rowspan++;
					} else {
						break;
					}
				}

				return {
					rowspan: rowspan,
					colspan: 1
				};
			} else {
				// 其他列（时间、血氧等额外列）不合并
				return {
					rowspan: 1,
					colspan: 1
				};
			}
		},

		showSizeChange(data) {
			console.log(data);
			this.current = data;
			this.getTableData(this.current, this.pageSize, this.preDate);
		},

		getTableData(pageNum = 1, pageSize = 20, preDate) {
			let param2 = { startDate: preDate, pageNum: pageNum, pageSize: pageSize };
			this.$get(
				'/api/healthDataSumCum/healthDataSumPage',
				param2,
				(res) => {
					if (res.code == 0) {
						if (pageSize >= 20000) {
							let resData = this.listDataMinToH(res.data.healthDataSumVoPage.records);
							this.copyTableData = JSON.parse(JSON.stringify(resData));
							this.copyTableData = this.changeDataList(resData);
						} else {
							let resData = this.listDataMinToH(res.data.healthDataSumVoPage.records);
							this.tableData = resData;
							this.current = res.data.healthDataSumVoPage.current;
							this.pages = res.data.healthDataSumVoPage.pages;
							this.total = res.data.healthDataSumVoPage.total;
							this.calculateSpanMethods(); // 触发合并计算
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => { /* this.$message.error('服务端发生异常'); */ }
			);
		},

		getGuardElderInfo() {
			let param2 = {};
			this.$get(
				'/api/dean/v5/guardElderInfo',
				param2,
				(res) => {
					if (res.code == 0 && res.data) {
						this.dayNumber = res.data.dayNumber;
						this.elderNumber = res.data.elderNumber;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => { /* this.$message.error('服务端发生异常'); */ }
			);
		},

		changeTableRowColor({ row, rowIndex }) {
			if (this.currentHoverGroup.includes(rowIndex)) {
				return "merge-hover-row";
			}
			const displayIndex = this.displayRowIndexes.indexOf(rowIndex);
			if (displayIndex !== -1) {
				return displayIndex % 2 !== 0 ? "statistics-warning-row" : "";
			} else {
				let firstIndex = this.findNumber(this.displayRowIndexes, rowIndex);
				return this.displayRowIndexes.indexOf(firstIndex) % 2 !== 0 ? "statistics-warning-row" : "";
			}
		},

		findNumber(arr, index) {
			return arr.reduce((result, num) => num <= index ? num : result, undefined);
		},

		renderheader(h, { column, $index }) {
			return h('span', {}, [
				h('span', {}, column.label.split('/')[0]),
				h('br'),
				h('span', {}, column.label.split('/')[1])
			]);
		},

		toExportExcele(event) {
			let target = event.target;
			if (target.nodeName == 'SPAN') target = event.target.parentNode;
			target.blur();
			let param2 = { startDate: this.preDate };
			this.$get(
				'api/healthDataSumCum/healthDataSumExport',
				param2,
				(res) => {
					if (res.code == 0) {
						var a = document.createElement('a');
						a.href = `/api/healthDataSumCum/downloadFile?filePath=${res.data}`;
						a.style.display = 'none';
						document.body.appendChild(a);
						a.click();
						a.remove();
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => { /* this.$message.error('服务端发生异常'); */ }
			);
		},

		toExportPdf() {
			htmlToPdf.downloadPDF(
				document.querySelector('#exportPdf'),
				'1-7 各级行政机构领导职数和在职人数反查明细表'
			);
		},

		changeDataList(data) {
			var newData = [];
			var zyf = 20;
			for (var i = 0; i < Math.ceil(data.length / zyf); i++) {
				newData[i] = [];
				newData[i].push(data[i * zyf]);
				for (var j = 1; j < zyf; j++) {
					if (data[i * zyf + j] == undefined) return newData;
					newData[i].push(data[i * zyf + j]);
				}
			}
			return newData;
		},

		listDataMinToH(data) {
			data.forEach((item) => {
				for (let key in item) {
					if (key === 'sleepLenValidMin' || key === 'outBedDuration') {
						item[key + 'text'] = this.timeChange2(item[key]);
					}
					if (key === 'sleepEff') {
						item[key + 'text'] = item[key] + '%';
					}
				}
			});
			return data;
		},

		timeChange2(data) {
			let getTime = '';
			let h = Math.floor(data / 60);
			let min = data - h * 60;
			getTime = data == 0 ? '0min' : h > 0 ? `${h}h${min}min` : `${min}min`;
			return getTime;
		}
	},
	beforeDestroy() { },
};
</script>

<!-- 原有 scoped 样式 -->
<style lang="scss" scoped>
@media print {
	.pointPdf1 {
		padding-top: 10px;
	}

	.cell span {
		white-space: nowrap;
	}

	tr:last-child {
		border-bottom: 1px solid #262626;
	}
}

.data-summary {
	background: #fff;
	height: 100vh !important;

	.pointPdf1 {
		position: fixed;
		top: 0;
		left: 99999999px;
	}

	.abnormal {
		color: rgba(255, 77, 79, 1);
	}
}

::v-deep .el-table td {
	padding: 6px 0;
	background-clip: padding-box;
}

::v-deep .el-table .cell {
	font-weight: normal;
}

.page-title {
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;

	.text {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #262626;
	}

	.btn {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-direction: row-reverse;
	}
}

.pagination {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 20px 0;
	padding-bottom: 20px;
}
</style>

<!-- 原有全局样式 -->
<style lang="scss">
.data-summary {
	.statistics-warning-row {
		background: rgba(250, 250, 250, 1);
	}

	.el-table td {
		padding: 6px 0;
		background-clip: padding-box;
	}

	.el-table .cell {
		font-weight: normal;
	}

	.el-table--enable-row-transition .el-table__body td.el-table__cell {
		background: unset !important;
	}

	.merge-hover-row {
		background-color: rgba(246, 247, 250, 1) !important;
		transition: background-color 0.2s ease;
	}
}
</style>